import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { storeLastAuthMethod } from '@/lib/auth-prefs'
import '@/styles/aura-auth.css'

export function AuthCallback() {
  const navigate = useNavigate()
  const { setAuth } = useAuth()

  useEffect(() => {
    // Token is delivered in URL fragment (#) so it never appears in
    // Referer headers or server access logs. Clear it immediately after reading.
    const hash = window.location.hash.startsWith('#')
      ? window.location.hash.slice(1)
      : window.location.hash
    const params = new URLSearchParams(hash)
    const token = params.get('token')
    const userParam = params.get('user')

    if (token && userParam) {
      try {
        const user = JSON.parse(decodeURIComponent(userParam))
        setAuth(token, user)
        // Remember how this browser signed in, for the login page's label.
        if (user.auth_provider === 'google' || user.auth_provider === 'github') {
          storeLastAuthMethod(user.auth_provider)
        }
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
        // Deep links (e.g. /invite/:token) survive the OAuth round-trip
        const returnTo = sessionStorage.getItem('aura_return_to')
        sessionStorage.removeItem('aura_return_to')
        if (returnTo) {
          navigate(returnTo, { replace: true })
        } else if (user.role === 'admin') {
          navigate('/admin', { replace: true })
        } else if (user.role === 'recruiter') {
          navigate('/recruiter', { replace: true })
        } else if (user.role === '') {
          navigate('/choose-role', { replace: true })
        } else {
          navigate('/dashboard', { replace: true })
        }
      } catch {
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
        navigate('/', { replace: true })
      }
    } else {
      navigate('/', { replace: true })
    }
  }, [setAuth, navigate])

  return (
    <div className="aura-auth-page">
      <div className="auth-ambient" aria-hidden="true"></div>
      <div className="auth-mesh" aria-hidden="true"></div>
      <main className="auth-inner">
        <div className="loading-state" role="status" aria-live="polite" style={{ minHeight: 'auto' }}>
          <div className="spinner" aria-hidden="true"></div>
          <span>Signing you in…</span>
        </div>
      </main>
    </div>
  )
}
